export const HeadingH = () => (
  <path
    d='M14.9376 17C14.7995 17 14.6876 16.8881 14.6876 16.75V12.8872C14.6876 12.7491 14.5757 12.6372 14.4376 12.6372H9.56239C9.42432 12.6372 9.31239 12.7491 9.31239 12.8872V16.75C9.31239 16.8881 9.20046 17 9.06239 17H7.75C7.61193 17 7.5 16.8881 7.5 16.75V7.25C7.5 7.11193 7.61193 7 7.75 7H9.06239C9.20046 7 9.31239 7.11193 9.31239 7.25V10.843C9.31239 10.981 9.42432 11.093 9.56239 11.093H14.4376C14.5757 11.093 14.6876 10.981 14.6876 10.843V7.25C14.6876 7.11193 14.7995 7 14.9376 7H16.25C16.3881 7 16.5 7.11193 16.5 7.25V16.75C16.5 16.8881 16.3881 17 16.25 17H14.9376Z'
    fill='currentColor'
  />
)
